// noinspection JSNonASCIINames,NonAsciiCharacters

export const currencyTranslations = {
    currency: {
        commonUsedGroup: "Часто используемые",
        otherGroup: "Другие",
        "EUR": "Евро",
        "USD": "Доллар США",
        "GBP": "Фунт стерлингов",
        "PLN": "Польский злотый",
        "SEK": "Шведская крона",
        "NOK": "Норвежская крона",
        "CZK": "Чешская крона",
        "PHP": "Филиппинское песо",
        "UAH": "Украинская гривна",
        "ISK": "Исландская крона",
        "CAD": "Канадский доллар",
        "CHF": "Швейцарский франк",
        "AUD": "Австрал. доллар",
        "RUB": "Российский рубль",
        "VND": "Вьетнамский донг",
        "INR": "Индийская рупия",
        "CNY": "Китайский юань",
        "HUF": "Венгерский форинт",
        "RON": "Румынский лей",
    }
}